// src/app/utils/string-utils.ts
export function toKebabCase(value: string): string {
    return value
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
        .toLowerCase();
}

/** Vendor display name: 1) businessName if present, 2) else firstName + lastName (or only one if same). */
export function getVendorDisplayName(vendor: { businessName?: string; firstName?: string; lastName?: string } | null | undefined, fallback = 'N/A'): string {
    if (!vendor) return fallback;
    const businessName = (vendor.businessName ?? '').trim();
    if (businessName) return businessName;
    const first = (vendor.firstName ?? '').trim();
    const last = (vendor.lastName ?? '').trim();
    if (first || last) {
        if (first && last && first.toLowerCase() !== last.toLowerCase()) {
            return `${first} ${last}`;
        }
        return first || last;
    }
    return fallback;
}
